import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { setSession } from "../store/slices/sessionSlice";
import { SessionManager } from "../utils/sessionManager";

export function useSession() {
  const session = useSelector((state: RootState) => state.sessionManager);
  const dispatch = useDispatch();

  const getSessionAndRequestId = () => {
    const {
      session: updated,
      requestId,
      isNewSession,
    } = SessionManager.getNextRequest(session);

    dispatch(setSession(updated));

    return { sessionId: updated.sessionId, requestId, isNewSession };
  };

  const stopSession = () => {
    const newSession = SessionManager.stopSession(session);
    dispatch(setSession(newSession));

    return { session: newSession };
  };

  const startNewTopic = () => {
    const newSession = SessionManager.startNewTopic();
    dispatch(setSession(newSession));

    return { session: newSession };
  };

  const startAiPoweredAnalysis = () => {
    const newSession = SessionManager.startNewTopic();

    const updated = {
      ...newSession,
      callCount: 1,
    };

    dispatch(setSession(updated));

    return { session: newSession };
  };

  return {
    getSessionAndRequestId,
    stopSession,
    startNewTopic,
    startAiPoweredAnalysis,
  };
}
